import { Trash2 } from "lucide-react";
// W37.0 §4.6: ActionSheet became PA6 in `components/patterns/`. This helper
// stays in `system/` because it is a *caller's* convenience, not part of the
// pattern's contract — but the type it returns now comes from the pattern layer.
import type { ActionSheetAction } from "@/components/patterns/ActionSheet";

/**
 * Convenience helper: pre-built "delete" action for ActionSheet.
 * Per mockup mobile.html §8.2, the first row of actionSheet is "移到垃圾桶"
 * with `data-tone="danger"` semantics.
 */
export function deleteAction(opts: {
  label?: string;
  onConfirm: () => void;
  testId?: string;
}): ActionSheetAction {
  return {
    id: "delete",
    label: opts.label ?? "移到垃圾桶",
    tone: "danger",
    leadingIcon: <Trash2 size={18} aria-hidden />,
    onClick: opts.onConfirm,
    testId: opts.testId,
  };
}
